var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"back"},[_c('div',{staticClass:"text"},[_vm._v("河北鲸诚信用服务有限公司独家运营，旨在为中小企业提供一体化代办服务。")]),_c('div',{staticClass:"phone"},[_c('span',[_vm._v("联系电话:400-056-5663")]),_c('span',[_vm._v("客服微信:鲸诚信")])])]),_c('div',{staticClass:"number"},[_c('div',[_vm._v("©2020-2024 河北鲸诚信用服务有限公司 版权所有")])])])
}]

export { render, staticRenderFns }